module.exports = __webpack_public_path__ + "static/img/movue.3d6516f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/movue.png
// module id = RHgT
// module chunks = 1